module.exports = __webpack_public_path__ + "static/img/icon-unknow.798b91f6.svg";